export const PLACEMENT_MAP_LTR = {
    'bottom': 'bottom-start',
    'bottom-end': 'bottom-end',
    'top': 'top-start',
    'top-end': 'top-end',
};
export const PLACEMENT_MAP_RTL = {
    'bottom': 'bottom-end',
    'bottom-end': 'bottom-start',
    'top': 'top-end',
    'top-end': 'top-start',
};
export const WIDTH_CLASSES = {
    base: 'nucleus-w-input-base',
    xs: 'nucleus-w-input-xs nucleus-self-stretch',
    sm: 'nucleus-w-input-sm nucleus-self-stretch',
    lg: 'nucleus-w-input-lg nucleus-self-stretch',
    full: 'nucleus-w-input-full nucleus-self-stretch',
};
// Section divider: a full-width line with 4px of space above and below so
// grouped items read as distinct sections.
export const DROPDOWN_SEPARATOR_CLASSES = 'nucleus-my-1 nucleus-border-0 nucleus-border-t nucleus-border-solid nucleus-border-neutral-200 dark:nucleus-border-neutral-300';
/** Identifies an option row in the DOM so navigation can move focus without holding element refs. */
export const DROPDOWN_ITEM_ID_ATTRIBUTE = 'data-dropdown-item-id';
/** Distance in pixels from the end of the list at which the next page is requested. */
export const SCROLL_LOAD_THRESHOLD = 20;
/** Horizontal travel of a level entering the panel, in pixels. */
export const PANEL_ENTER_OFFSET = 12;
/**
 * A compact options sheet shows a search field once a level has at least this many options.
 * Shorter levels stay a plain list; nested levels can opt in earlier with `children.searchable`.
 * Levels that still have another page (`children.hasMore`) skip the field: it only filters options already rendered.
 */
export const SHEET_SEARCH_MIN_ITEMS = 6;
//# sourceMappingURL=dropdown.constants.js.map